import { render, staticRenderFns } from "./Excepcion.vue?vue&type=template&id=245e9e13"
import script from "./Excepcion.vue?vue&type=script&lang=js"
export * from "./Excepcion.vue?vue&type=script&lang=js"
import style0 from "./Excepcion.vue?vue&type=style&index=0&id=245e9e13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports